import { MainLayout } from "@/layouts/MainLayout/MainLayout";
import { NotFoundPage } from "@/pages/NotFoundPage/NotFoundPage";
import { Providers } from "@/providers/Providers";
import { RouterContext } from "@/types/router.types";
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";

export const Route = createRootRouteWithContext<RouterContext>()({
	component: RootComponent,
	notFoundComponent: NotFoundPage,
});

function RootComponent() {
	return (
		<Providers>
			<MainLayout>
				<Outlet />
			</MainLayout>
			<TanStackRouterDevtools />
		</Providers>
	);
}
